import React, { useState, useEffect, useContext } from 'react';
import { Grid, Stack, Avatar, IconButton, Typography, Button, Paper, Card, Box, CardContent, Popper, CardMedia } from '@mui/material';
import { ExpandMore, Adb, ExpandLess, ChevronLeft, ChevronRight } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import MainCard from 'ui-component/cards/MainCard';
import LoginContext from 'Context/ContextLogin';
import { ReactComponent as IconUser } from 'assets/images/icons/avatar-sin-foto.svg';
import { useTheme } from '@mui/material/styles';
import Calendario from './Calendario';
import Contacto from '../ComponentsHomeVentas/Contacto';
import 'react-multi-carousel/lib/styles.css';
import Services from 'utils/serviciosVentas';
import ItemMensajes from './ItemMensajes';
import { ModalGeneral } from 'ui-component';
import moment from 'moment';
import 'moment/locale/es';
import ItemCarousel from './ItemCarousel';

const useStyle = makeStyles((theme) => ({
    principal: {
        position: 'relative',
        width: '100%'
    },
    boton: {
        position: 'fixed',
        right: '30px',
        bottom: '10px'
    },
    root: {
        minWidth: '100%',
        backgroundColor: '#E0E0E0',
        marginRight: '20px',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)'
    },
    title: {
        fontSize: 14
    },
    pos: {
        marginBottom: 12
    },
    btnCancelar: {
        color: theme.palette.btn.red,
        '&:hover': {
            backgroundColor: theme.palette.btn.red,
            color: theme.palette.btn.white
        }
    }
}));

const ItemNumero = (props) => {
    const { color, num, msj } = props;
    return (
        <Card sx={{ width: '100%', backgroundColor: color }}>
            <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant="h3" gutterBottom>
                    {num}
                </Typography>
                <Typography variant="body2" component="p">
                    {msj}
                </Typography>
            </CardContent>
        </Card>
    );
};

const InicioV2 = (props) => {
    const { usuario, selectCurso, setCargando, option, esIncognito } = props;
    const services = Services();
    const classes = useStyle();
    const theme = useTheme();
    const context = useContext(LoginContext);
    const [cursos, setCursos] = useState([]);
    const [avisos, setAvisos] = useState([]);
    const [notificaciones, setNotificaciones] = useState([]);
    const [modal, setModal] = useState({ open: false, props: null, componente: null });

    const [anchorEl, setAnchorEl] = React.useState(null);

    const cerrarModal = () => {
        setModal({
            ...modal,
            open: false
        });
    };

    const abrirMensajeCalendario = (data) => {
        const fe = moment(data.fecha).locale('es').format('DD-MMMM-YYYY');
        setModal({
            open: true,
            titulo: 'Actividad programada',
            mensaje: `${fe} - ${data.titulo}`
        });
    };

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const creaFechaActual = (item) => {
        if (item.periodo == 'ANUAL') {
            const actual = new Date();
            const year = actual.getFullYear();
            let f = item.ini;
            let arrFecha = f.split('-');
            //let nuevaFecha = year + '-' + arrFecha[1] + '-' + arrFecha[2];
            return `${year}-${arrFecha[1]}-${arrFecha[2]}`;
        } else {
            return item.ini;
        }
    };

    useEffect(() => {
        if (usuario && usuario != null) {
            setCargando({ open: true });
            const idcrm = usuario.idCRM ? usuario.idCRM : null;
            services.buscaCursosColab(
                (data) => {
                    setCargando({ open: false });

                    let listaCursos = [...data?.cursos];

                    let arr = [];
                    let noti = [];
                    data?.cursos.forEach((cur) => {
                        arr.push({
                            id: cur.idCurso,
                            date: cur.fechaInicio,
                            title: `Inicio de curso '${cur.titulo}'`,
                            desc: `El curso comienza el día ${moment(cur.fechaInicio).locale('es').format('DD-MMMM-YYYY')}`,
                            tipo: 'curso'
                        });
                        arr.push({
                            id: cur.idCurso,
                            date: cur.fechaFin,
                            title: `Fin curso ${cur.titulo}`,
                            desc: `El curso termina el día ${moment(cur.fechaFin).locale('es').format('DD-MMMM-YYYY')}`,
                            tipo: 'curso'
                        });

                        noti.push({
                            id: cur.idCurso,
                            date: cur.fechaInicio,
                            title: `Inicio de curso '${cur.titulo}'`,
                            desc: `El curso comienza el día ${moment(cur.fechaInicio).locale('es').format('DD-MMMM-YYYY')}`,
                            tipo: 'curso'
                        });
                        noti.push({
                            id: cur.idCurso,
                            date: cur.fechaFin,
                            title: `Fin curso ${cur.titulo}`,
                            desc: `El curso termina el día ${moment(cur.fechaFin).locale('es').format('DD-MMMM-YYYY')}`,
                            tipo: 'curso'
                        });
                    });

                    data?.notificaciones.forEach((el) => {
                        // let fecha = creaFechaActual(el);
                        // el.inicio = fecha;
                        if (el.slide == 1) {
                            listaCursos.push(el);
                        } else {
                            noti.push({
                                id: el.idnotificacion,
                                date: el.inicio,
                                fechaFin: el.fin,
                                title: el.anuncio,
                                tipo: 'mensaje',
                                desc: el.Descripcion,
                                periodo: el.periodo
                            });
                        }
                    });

                    setCursos([...listaCursos]);

                    setAvisos([...arr]);

                    setNotificaciones([...noti]);
                },
                {
                    idColaborador: usuario.idColaborador,
                    idGrupo: usuario.idGrupo,
                    option,
                    idContrato: usuario.idcontrato,
                    depto: usuario.depto,
                    idcrm: idcrm
                }
            );
        }
    }, [usuario]);

    return (
        <>
            <div className={classes.principal}>
                <MainCard>
                    <Grid container spacing={1} alignItems="center">
                        {!esIncognito && (
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                {/* <Typography variant="h1">hola</Typography> */}
                                {/* <ProfileSection /> */}
                                <Paper
                                    style={{
                                        width: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        padding: '10px',
                                        color: '#b6a268',
                                        border: 'solid 1px #b6a268',
                                        borderRadius: '30px'
                                    }}
                                >
                                    <Avatar
                                        sx={{
                                            ...theme.typography.mediumAvatar,
                                            // margin: '8px 0 8px 8px !important',
                                            cursor: 'pointer',
                                            width: 50,
                                            height: 50
                                        }}
                                        aria-haspopup="true"
                                        color="inherit"
                                    >
                                        {context?.login?.usuario?.foto ? (
                                            <img alt="fotoPerfil" src={context?.login?.usuario?.foto} width={50} height={50} />
                                        ) : (
                                            <IconUser />
                                        )}
                                    </Avatar>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            color: '#b6a268'
                                        }}
                                    >
                                        <Stack>
                                            <Stack alignItems="left">
                                                <Typography variant="title" sx={{ color: '#b6a268', padding: '5px' }}>
                                                    {`${context.login?.usuario?.nombre}`}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack>
                                            {/* <Button  aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                                            Open Menu
                                        </Button> */}
                                            <IconButton
                                                sx={{ color: '#b6a268' }}
                                                variant="contained"
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                aria-describedby={id}
                                                onClick={handleClick}
                                                component="span"
                                            >
                                                {open == true ? <ChevronLeft /> : <ChevronRight />}
                                            </IconButton>
                                        </Stack>
                                    </div>
                                </Paper>
                                <Popper Popper id={id} open={open} anchorEl={anchorEl} placement="right">
                                    <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                        <Box sx={{ p: 2 }}>
                                            <Stack>
                                                <Stack direction="row" spacing={0.5} alignItems="center">
                                                    <Typography variant="h4">{`${context.login?.usuario?.nombre} (${context.login?.usuario?.nrol})`}</Typography>
                                                </Stack>
                                                <Typography variant="subtitle2">{context.login?.usuario?.email}</Typography>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Typography variant="bodyInfo">{context.login?.usuario?.sede}</Typography>
                                                    <Typography variant="bodyInfo">{context.login?.usuario?.idcontrato}</Typography>
                                                </Box>
                                            </Stack>
                                        </Box>
                                    </MainCard>
                                </Popper>
                            </Grid>
                        )}
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ItemCarousel cursos={cursos} selectCurso={selectCurso} />
                        </Grid>
                        {!esIncognito && (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                lg={6}
                                sx={{ backgroundColor: '#E0F7FA', color: '#000000', borderRadius: '30px', p: 2 }}
                            >
                                <Calendario eventos={avisos} accion={abrirMensajeCalendario} />
                            </Grid>
                        )}

                        <Grid item xs={12} sm={12} md={6} lg={6} container spacing={2}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <ItemNumero
                                    color="#EF9A9A"
                                    num={cursos?.length > 0 ? cursos.filter((x) => x.numCalif == 0 && x.isAprobado == 0).length : 0}
                                    msj="Cursos sin comenzar"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <ItemNumero
                                    color="#FFF59D"
                                    num={cursos?.length > 0 ? cursos.filter((x) => x.isAprobado == 0 && x.numCalif > 0).length : 0}
                                    msj="Cursos en proceso"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <ItemNumero
                                    color="#69F0AE"
                                    num={cursos?.length > 0 ? cursos.filter((x) => x.isAprobado == 1).length : 0}
                                    msj="Cursos completados"
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Contacto infoCotac={usuario} />
                            {/* <SubCardCollapase openCollapse title="Contacto">
                               
                            </SubCardCollapase> */}
                        </Grid>
                    </Grid>
                </MainCard>
            </div>

            {!esIncognito && (
                <div className={classes.boton}>
                    <ItemMensajes avisos={notificaciones} />
                </div>
            )}

            <ModalGeneral
                open={modal.open}
                titulo={modal.titulo}
                ContenidoMensaje={modal.mensaje}
                width="sm"
                acciones={
                    <Button onClick={cerrarModal} className={classes.btnCancelar}>
                        Cerrar
                    </Button>
                }
            >
                {modal.componente && <modal.componente {...modal.props} />}
            </ModalGeneral>
        </>
    );
};

export default InicioV2;
